import { useQuery } from "@tanstack/react-query";

import type { Query } from "../api/BaseAPI";
import type {
  DataTablePage,
  DataTableQueryResult,
} from "../components/dataTable/dataTable.types";

const NO_ROW_LIST: never[] = [];

// `select` doit être une fonction de module : React Query ne le relance que si elle change.
export default function useDataTableQuery<TResponse, TData>(
  query: Query<TResponse>,
  select: (response: TResponse) => DataTablePage<TData>,
): DataTableQueryResult<TData> {
  const {
    data: page,
    isLoading,
    isPreviousData,
    isError,
    refetch,
  } = useQuery({ ...query, keepPreviousData: true, select });

  return {
    data: page?.rows ?? NO_ROW_LIST,
    rowCount: page?.rowCount ?? 0,
    isLoading: isLoading || isPreviousData,
    isError,
    onRetry: refetch,
  };
}
